import { css } from '@emotion/css';

import { Spacing } from 'apps/shared/scripts/styles/constants';

export const emojiClassName = css({
  bottom: Spacing.MD,
  right: Spacing.SM,
});

export const alertClassName = css({
  '--bs-alert-padding-y': `${Spacing.SM}px !important`,
});
